import script from "./ProjectDonateField.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDonateField.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDonateField.vue?vue&type=style&index=0&id=15c59a8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c59a8a"]])

export default __exports__